import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";

// router setup
import routes from "./routes/routes";
// vuex setup
import { store } from "./store/index";
// mixins
import * as mixins from "@/mixins/mixins";
import * as dataTable from "@/mixins/dataTable";
// ENV config
// require("dotenv").config();

import firebase from "./services/firebase-init";
import "firebase/messaging";
// vue mask
import VueTheMask from "vue-the-mask";

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VueTheMask);

// configure router
const router = new VueRouter({
  mode: "history", // remove # in URL and enable open in new tab
  routes, // short for routes: routes
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active",
});

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
};

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && !(await firebase.getCurrentUser())) {
    next("/");
  } else {
    next();
  }
});

router.beforeEach(async (to, from, next) => {
  let permission = localStorage.getItem("permission");
  if (
    to.path != "/" &&
    to.path != "/products" &&
    to.path != "/print-bill" &&
    to.path != "/wines-accessories"
  ) {
    if (permission) {
      permission = permission.split(",");
      let path = to.path.substring(1);
      if (permission.includes(path)) {
        next();
      } else {
        next("/" + permission[0]);
      }
    } else {
      next("/");
    }
  } else {
    next();
  }
});
// global library setup
Vue.prototype.$Chartist = Chartist;
// global mixin
Object.keys(mixins).forEach((key) => {
  Vue.mixin(mixins[key]);
});
Object.keys(dataTable).forEach((key) => {
  Vue.mixin(dataTable[key]);
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
});
